(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-topbar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.rh-localization[open]').forEach((selector) => {
      if (!selector.contains(event.target)) selector.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rh-localization[open]').forEach((selector) => {
      const containsFocus = selector.contains(document.activeElement);
      selector.removeAttribute('open');
      if (containsFocus) selector.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
